<template>
  <div class="view">

  <box :label="''+filteredClients.length+' kunder'">

    <template slot="meta-r">
      <div class="textlink" @click="createNewClient()">Ny kunde</div>
    </template>

    <div class="grid">
				<div class="col m30">
					<inputfield label="Søg">
						<input type="text" placeholder="Søg" :value="search_filter" ref="search_filter" v-on:keyup="search_filter_updated">
					</inputfield>
				</div>
				<div class="col m40">
				</div>
				<div class="col m30">
				</div>
			</div>

    <table class="table-a" v-if="filteredClients.length">      
      <tr>
        <th></th>
        <th class="align-l"></th>
        <th class="align-c">Aktive opgaver</th>
        <th class="align-c">Afsluttede opgaver</th>
        <th v-if="false && is_admin" class="align-r">Samlet indtjening</th>
      </tr>
      <tr v-for="(client,i) in filteredClients">
        <td><avatar :input="client"></avatar></td>
        <td class="align-l">
          <router-link class="textlink" :to="'/client/'+client['.key']">{{client.name}}</router-link>
        </td>
        <td class="align-c">
          {{client.active_projects_count}}            
        </td>
        <td class="align-c">
          {{client.finished_projects_count}}
        </td>          
        <td v-if="false && is_admin" class="align-r">
          {{clientTotalEarning(client['.key'])}}
        </td>
      </tr>    
		</table>

	</box>

  <btn @click.native="createNewClient()">Opret ny kunde</btn>

  <box v-if="show_debug_data_boxes" label="Dev data">
    <pre>{{filteredClients}}</pre>
  </box>  

  </div>
</template>

<script>
import moment from 'moment'
import helpers from '../helpers.js'
import mixins from '../mixins.js'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
import Inputfield from '.././components/Inputfield'
import fdb from '.././firebase_config.js'
export default {
  name: 'clients',
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      globals: this.$parent.globals,
    }
  },
  computed:{

    search_filter(){ return globals.clients.search_filter },

    filteredClients(){
      var output = []
			var clients = this.$store.getters['clients/getAll']
      if( !clients ) return output      

      var filterString = this.search_filter
			if( !filterString || filterString == undefined || filterString == '' ) filterString = undefined
      if(filterString) filterString = filterString.toLowerCase()     
      
      for( let client of clients ) {
        
        if( client.archived ) continue

        if( filterString ) {
					var filter_match = ( client.name && client.name.toLowerCase().indexOf(filterString) >= 0 )
					if(!filter_match) continue
        }

        client.active_projects_count = this.getClientProjects(client.key, { only_active:true, not_archived:true }).length
        client.finished_projects_count = this.getClientProjects(client.key, { only_finished:true, not_archived:true }).length        
        
        output.push( client )
      }

      output = output.sort((a,b)=>{ return ((b.active_projects_count*1000)+(b.finished_projects_count)) - ((a.active_projects_count*1000)+(a.finished_projects_count)) })

      return output
    }

  },//computed
  methods: {

    getProjectBudgetTotal: helpers.getProjectBudgetTotal,
    getProjectHoursEstimate: helpers.getProjectHoursEstimate,
    outputMoney: helpers.outputMoney,
    clientTotalEarning: helpers.clientTotalEarning,
    getClientProjects: helpers.getClientProjects,
    getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,

    getObjSize(obj){
      return Object.keys(obj).length
    },

    gotoClient(client){
      this.$router.push('client/'+client['.key'])
    },

    search_filter_updated(){
			globals.clients.search_filter = this.$refs.search_filter.value			
		},


    incrementGlobalCount(){
		  //console.log(this.$root)
		  //this.$parent.globals.count++
		  window.globals.count++
	  },

    createNewClient(){
      var new_entry = fdb.ref('clients').push({
        name: 'Ny kunde',
        created: moment().unix(),
      })
      var new_entry_key = new_entry.getKey()
  		this.$router.push('client/'+new_entry_key)

    },

  },//methods
  components: { Box, Btn, Avatar, Inputfield },
}
</script>



// WEBPACK FOOTER //
// Clients.vue?34c1e4df